"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uomOptions = void 0;

var data_1 = require("./data");

exports.uomOptions = {
  quantity: {
    accessories: [data_1.lbs, data_1.pcs],
    angle: [data_1.lbs, data_1.pcs],
    bar: [data_1.lbs, data_1.pcs, data_1.ft, data_1.inch],
    bushing: [data_1.pcs],
    cap: [data_1.pcs],
    carbon: [data_1.lbs, data_1.pcs],
    channelPlankGrating: [data_1.lbs, data_1.pcs, data_1.sqft],
    coil: [data_1.lbs, data_1.ft],
    coiledBar: [data_1.lbs],
    coiledDrawnWire: [data_1.lbs],
    coiledTread: [data_1.lbs],
    coiledTube: [data_1.lbs, data_1.ft],
    comfab: [data_1.lbs, data_1.pcs],
    coupling: [data_1.pcs],
    cross: [data_1.lbs, data_1.pcs],
    customProfile: [data_1.lbs, data_1.pcs, data_1.ft],
    cutCoil: [data_1.lbs, data_1.pcs],
    elbow: [data_1.pcs],
    expandedMetal: [data_1.lbs, data_1.pcs, data_1.sqft],
    fasteners: [data_1.pcs],
    finishedPart: [data_1.lbs, data_1.pcs, data_1.ft],
    flange: [data_1.pcs],
    flat: [data_1.lbs, data_1.pcs, data_1.ft, data_1.inch],
    flooring: [data_1.lbs, data_1.pcs, data_1.sqft],
    forgedSteel: [data_1.lbs, data_1.pcs],
    gripStrut: [data_1.lbs, data_1.pcs],
    insert: [data_1.lbs, data_1.pcs],
    ladderRung: [data_1.lbs, data_1.pcs],
    lawnEdging: [data_1.lbs, data_1.pcs],
    misc: [data_1.lbs, data_1.pcs],
    nipple: [data_1.pcs],
    oLet: [data_1.pcs],
    other: [data_1.lbs, data_1.pcs],
    panel: [data_1.lbs, data_1.pcs, data_1.sqft],
    perforatedSheet: [data_1.lbs, data_1.pcs, data_1.sqft],
    pipe: [data_1.lbs, data_1.pcs, data_1.ft, data_1.inch],
    plate: [data_1.lbs, data_1.pcs, data_1.sqft, data_1.sqin],
    plug: [data_1.pcs],
    reducer: [data_1.pcs],
    roll: [data_1.lbs],
    round: [data_1.lbs, data_1.pcs, data_1.ft, data_1.inch],
    sheet: [data_1.lbs, data_1.pcs, data_1.sqft, data_1.sqin],
    square: [data_1.lbs, data_1.pcs, data_1.ft, data_1.inch],
    stainless: [data_1.lbs, data_1.pcs],
    stairTread: [data_1.lbs, data_1.pcs],
    structural: [data_1.lbs, data_1.pcs, data_1.ft, data_1.inch],
    stubEnd: [data_1.pcs],
    swage: [data_1.pcs],
    tee: [data_1.lbs, data_1.pcs, data_1.ft, data_1.inch],
    treadPlate: [data_1.lbs, data_1.pcs, data_1.sqft],
    tube: [data_1.lbs, data_1.pcs, data_1.ft, data_1.inch],
    union: [data_1.pcs],
    valve: [data_1.pcs],
    weldingSpud: [data_1.lbs, data_1.pcs]
  },
  price: {
    accessories: [data_1.lb, data_1.cwt, data_1.pc],
    angle: [data_1.lb, data_1.pc],
    bar: [data_1.lb, data_1.cwt, data_1.pc, data_1.ft, data_1.inch],
    bushing: [data_1.pc],
    cap: [data_1.pc],
    carbon: [data_1.lb, data_1.pc],
    channelPlankGrating: [data_1.lb, data_1.cwt, data_1.pc, data_1.sqft],
    coil: [data_1.lb, data_1.cwt, data_1.ft],
    coiledBar: [data_1.lb, data_1.cwt],
    coiledDrawnWire: [data_1.lb, data_1.cwt],
    coiledTread: [data_1.lb, data_1.cwt],
    coiledTube: [data_1.lb, data_1.cwt, data_1.ft],
    comfab: [data_1.lb, data_1.cwt, data_1.pc],
    coupling: [data_1.pc],
    cross: [data_1.lb, data_1.pc],
    customProfile: [data_1.lb, data_1.cwt, data_1.pc, data_1.ft],
    cutCoil: [data_1.lb, data_1.pc],
    elbow: [data_1.pc],
    expandedMetal: [data_1.lb, data_1.cwt, data_1.pc, data_1.sqft],
    fasteners: [data_1.pc],
    finishedPart: [data_1.lb, data_1.cwt, data_1.pc, data_1.ft],
    flange: [data_1.pc],
    flat: [data_1.lb, data_1.cwt, data_1.pc, data_1.ft, data_1.inch],
    flooring: [data_1.lb, data_1.cwt, data_1.pc, data_1.sqft],
    forgedSteel: [data_1.lb, data_1.pc],
    gripStrut: [data_1.lb, data_1.cwt, data_1.pc],
    insert: [data_1.lb, data_1.pc],
    ladderRung: [data_1.lb, data_1.cwt, data_1.pc],
    lawnEdging: [data_1.lb, data_1.cwt, data_1.pc],
    misc: [data_1.lb, data_1.pc],
    nipple: [data_1.pc],
    oLet: [data_1.pc],
    other: [data_1.lb, data_1.pc],
    panel: [data_1.lb, data_1.cwt, data_1.pc, data_1.sqft],
    perforatedSheet: [data_1.lb, data_1.cwt, data_1.pc, data_1.sqft],
    pipe: [data_1.lb, data_1.cwt, data_1.pc, data_1.ft, data_1.inch],
    plate: [data_1.lb, data_1.cwt, data_1.pc, data_1.sqft, data_1.sqin],
    plug: [data_1.pc],
    reducer: [data_1.pc],
    roll: [data_1.lb, data_1.cwt],
    round: [data_1.lb, data_1.cwt, data_1.pc, data_1.ft, data_1.inch],
    sheet: [data_1.lb, data_1.cwt, data_1.pc, data_1.sqft, data_1.sqin],
    square: [data_1.lb, data_1.cwt, data_1.pc, data_1.ft, data_1.inch],
    stainless: [data_1.lb, data_1.pc],
    stairTread: [data_1.lb, data_1.cwt, data_1.pc],
    structural: [data_1.lb, data_1.cwt, data_1.pc, data_1.ft, data_1.inch],
    stubEnd: [data_1.pc],
    swage: [data_1.pc],
    tee: [data_1.lb, data_1.cwt, data_1.pc, data_1.ft, data_1.inch],
    treadPlate: [data_1.lb, data_1.cwt, data_1.pc, data_1.sqft],
    tube: [data_1.lb, data_1.cwt, data_1.pc, data_1.ft, data_1.inch],
    union: [data_1.pc],
    valve: [data_1.pc],
    weldingSpud: [data_1.lb, data_1.pc]
  }
};